<template>
  <SvgSprite
    class="icon"
    :class="`icon-${icon}`"
    :symbol="icon"
    :width="size"
    :height="size"
  />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { SvgSprite } from 'vue-svg-sprite';

@Component({
  components: {
    SvgSprite,
  },
})
export default class Icon extends Vue {
  @Prop() icon!: string;
  @Prop({ default: 24 }) size!: number;
}
</script>
